import React, { memo } from 'react';
import { useVFXConfig } from '@/features/vfx/hooks/useVFXConfig';
import BackgroundLayer from '@/features/vfx/components/BackgroundLayer';
import VFXCanvas from '@/features/vfx/components/VFXCanvas';
import SupportFooter from '@/features/support/components/SupportFooter';
import NotificationContainer from '@/components/NotificationContainer';
import AutoLogoutWarning from '@/components/AutoLogoutWarning';
import { useAutoRedirect } from '@/hooks/useAutoRedirect';
import { useKioskHeartbeat } from '@/hooks/useKioskHeartbeat';
import KioskOfflineOverlay from '@/components/KioskOfflineOverlay';

interface BaseLayoutProps {
  children: React.ReactNode;
}

// Stable sub-components so VFX/background updates don't re-render page content
const GlobalOverlays = memo(() => (
  <>
    <SupportFooter />
    <NotificationContainer />
    <AutoLogoutWarning />
    <KioskOfflineOverlay />
  </>
));
GlobalOverlays.displayName = 'GlobalOverlays';

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  const { vfxConfig, backgroundConfig } = useVFXConfig();

  useAutoRedirect();
  useKioskHeartbeat();

  return (
    <>
      <BackgroundLayer config={backgroundConfig} />
      <VFXCanvas config={vfxConfig} />
      {children}
      <GlobalOverlays />
    </>
  );
};

export default memo(BaseLayout);
